// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"f0f7d915","198":"ac9ed6f4","489":"ee2d280a","525":"c4bf8974"}[chunkId] + ".chunk.css";
};